import _ from 'lodash';

export function simpleCheck(deserialized, object, propertyName) {
    if (!_.isUndefined(object[propertyName])) {
        deserialized[propertyName] = object[propertyName];
    }
}
